import { Component } from "@angular/core";

@Component({
    selector: 'playbook',
    template: ``,
    styleUrls: ['./playbook.component.scss'],
    standalone: false
  })
  export class PlaybookComponent {
  }